export enum Roles {
    Admin = 'Admin', Seller = 'Seller', Buyer = 'Buyer', Marketing = 'Marketing', SuperAdmin = 'SuperAdmin'
}
